package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel

data class MerchantLocationDetailsUIState(
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val location: MerchantLocationResponseModel? = null,
    val title: String = "",
    val whatYouCouldGet: String = "",
    val address: String = "",
    val phoneNumber: String = "",
    val dialCode: String = "",
    val locationCoverImageFileName: String? = null,
    val locationCoverImageUrl: String? = null,
    val menuPhotoFileNames: List<String> = emptyList(),
    val removedMenuPhotoUrls: Set<String> = emptySet(),
    val photoPickerForMenu: Boolean = false,
    val titleError: String? = null,
    val addressError: String? = null,
    val phoneNumberError: String? = null
)
